import {z, type ZodType} from 'zod'

const numericRecordKeySchema = z.coerce.number().int().nonnegative()

export const AT_LEAST_ONE_ENTRY_MESSAGE = 'At least one entry must be provided'

export interface CreateNumericKeyRecordSchemaOptions {
    requireAtLeastOneEntry?: boolean
}

export function createNumericKeyRecordSchema<T extends ZodType>(valueSchema: T,
                                                                options?: CreateNumericKeyRecordSchemaOptions,) {
    const base = z.record(numericRecordKeySchema, valueSchema)
    if(options?.requireAtLeastOneEntry) {
        return base.refine((obj) => Object.keys(obj).length > 0, {message: AT_LEAST_ONE_ENTRY_MESSAGE})
    }
    return base
}
